import $ from 'jquery';

function toggleAnswers() {
    var ask = $('.js-ask'),
        answers = $('.js-answer'),
        storedAsk,
        currentAnswer;

    ask.click((e) => {
        let currentAsk = $(e.currentTarget);

        currentAnswer = currentAsk.parent().find('.js-answer');

        if (storedAsk !== currentAsk[0]) {
            answers.slideUp('fast');
            currentAnswer.slideDown('fast');
            storedAsk = currentAsk[0];
        } else {
            currentAnswer.slideToggle('fast');
        }
    });
}

toggleAnswers();